import { BaseFormPartInterface } from 'components/atoms/form/base/BaseFormPartInterface';
import { BaseInput } from 'components/atoms/form/base/BaseInput';
import { ReactElement } from 'react';
import styled, { css } from 'styled-components';
import { fontSize, mediaDown } from 'styles/mixins';
import { colors, grayScales } from 'styles/variables';

const MaterialInputStyled = styled.div`
  display: flex;

  input {
    ${fontSize(16)}
    border: 1px solid ${grayScales.gs300};
    border-radius: 5px 0 0 5px;
    border-right: none;
    box-sizing: border-box;
    margin: 0;
    padding: 8px 16px;
    width: 100%;

    ::placeholder {
      color: ${grayScales.gs400};

      ${mediaDown('desktop', css`
        ${fontSize(14)}
      `)}
    }
  }

  i {
    ${fontSize(24)}
    background-color: ${colors.white};
    border: 1px solid ${grayScales.gs300};
    border-left: none;
    border-radius: 0 5px 5px 0;
    color: ${grayScales.gs600};
    cursor: pointer;
    padding: 8px 16px;

    ${mediaDown('desktop', css`
      ${fontSize(18)}
      padding: 8px 12px;
    `)}
  }
`;

interface MaterialInputInterface extends BaseFormPartInterface {
  symbol: ReactElement;
  didClickSymbol?: () => void;
};

const MaterialInput = (props: MaterialInputInterface): React.ReactElement => (
  <MaterialInputStyled>
    <BaseInput {...props} />
    <i onClick={props.didClickSymbol}>{props.symbol}</i>
  </MaterialInputStyled>
);

export default MaterialInput;
